module.exports = __webpack_public_path__ + "static/media/Robot.4547a447.svg";